import { render } from "./ValiderDemandeModal.vue?vue&type=template&id=22db364d&ts=true"
import script from "./ValiderDemandeModal.vue?vue&type=script&lang=ts"
export * from "./ValiderDemandeModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__